import FlagSvg from './component.jsx'
export default FlagSvg
